export default __webpack_public_path__ + "static/media/login-bg-1.ba900e05.jpg";